import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { SplitPageLayout } from "shared/components";

export const SignUp = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <SplitPageLayout
      title='Sign Up Disabled'
      subtitle='New accounts are created by invitation only. Please contact your administrator.'
    />
  );
};
